import styled from 'styled-components';
import { Button, Input } from 'antd';

export const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
`;

export const TabSection = styled.div`
  display: flex;
  gap: 8px;
`;

export const TabButton = styled.button<{ active: boolean; type?: 'primary' | 'secondary'; $isDarkMode?: boolean }>`
  flex: 1;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ active, $isDarkMode }) => {
    if (active) {
      return `
        background: #007aff;
        color: #fff;
      `;
    } else {
      return `
        background: ${$isDarkMode ? '#2a2a2a' : '#f5f5f5'};
        color: ${$isDarkMode ? '#fff' : '#333'};

        &:hover {
          background: ${$isDarkMode ? '#3a3a3a' : '#e8e8e8'};
        }
      `;
    }
  }}
`;

export const SectionDivider = styled.div<{ $isDarkMode?: boolean }>`
  width: 100%;
  height: 1px;
  background: ${({ $isDarkMode }) => ($isDarkMode ? '#3a3a3a' : '#e0e0e0')};
  margin: 4px 0;
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InputRow = styled.div<{ $isDarkMode?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ $isDarkMode }) => ($isDarkMode ? '#2a2a2a' : '#f8f8f8')};
  padding: 6px 10px;
  border-radius: 6px;
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#3a3a3a' : '#e0e0e0')};
`;

export const InputLabel = styled.div<{ $isDarkMode?: boolean }>`
  font-size: 13px;
  font-weight: 500;
  min-width: 80px;
  color: ${({ $isDarkMode }) => ($isDarkMode ? '#ccc' : '#666')};
`;

export const StyledInput = styled(Input)<{ $isDarkMode?: boolean }>`
  flex: 1;
  border: none !important;
  background: transparent !important;
  padding: 4px 8px !important;
  font-size: 14px !important;
  box-shadow: none !important;

  &:focus {
    box-shadow: none !important;
  }

  .ant-input-suffix {
    font-size: 12px;
    color: ${({ $isDarkMode }) => ($isDarkMode ? '#888' : '#999')};
  }
`;

export const ClearButton = styled(Button)<{ $isDarkMode?: boolean }>`
  min-width: 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#3a3a3a' : '#e0e0e0')} !important;
  background: ${({ $isDarkMode }) => ($isDarkMode ? '#1a1a1a' : '#fff')} !important;

  &:hover {
    background: ${({ $isDarkMode }) => ($isDarkMode ? '#2a2a2a' : '#f5f5f5')} !important;
    border-color: #007aff !important;
  }

  .anticon {
    font-size: 12px;
    color: ${({ $isDarkMode }) => ($isDarkMode ? '#888' : '#999')};
  }
`;

export const SliderSection = styled.div<{ $isDarkMode?: boolean }>`
  padding: 6px 10px 12px 10px;
  background: ${({ $isDarkMode }) => ($isDarkMode ? '#2a2a2a' : '#f8f8f8')};
  border-radius: 6px;
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#3a3a3a' : '#e0e0e0')};

  .ant-slider {
    margin: 10px 0 6px 0;
  }

  .ant-slider-mark-text {
    font-size: 11px;
    color: ${({ $isDarkMode }) => ($isDarkMode ? '#888' : '#999')};
  }

  .ant-slider-dot {
    border-color: ${({ $isDarkMode }) => ($isDarkMode ? '#3a3a3a' : '#e0e0e0')};
  }
`;

export const CalculateButton = styled(Button)`
  width: 100%;
  height: 40px;
  background: #007aff !important;
  border: none !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff !important;

  &:hover {
    background: #0066dd !important;
  }
`;

export const ResultCard = styled.div<{ $isDarkMode?: boolean }>`
  background: ${({ $isDarkMode }) => ($isDarkMode ? '#1a1a1a' : '#f8fbff')};
  border: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#333' : '#cce0ff')};
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 10px;
  box-shadow: ${({ $isDarkMode }) =>
    $isDarkMode
      ? '0 2px 8px rgba(0, 0, 0, 0.3)'
      : '0 2px 8px rgba(0, 122, 255, 0.08)'
  };
`;

export const ResultRow = styled.div<{ $isDarkMode?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  min-height: 40px;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ $isDarkMode }) => ($isDarkMode ? '#2a2a2a' : '#e3f0ff')};
  }
`;

export const ResultLabel = styled.div<{ $isDarkMode?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${({ $isDarkMode }) => ($isDarkMode ? '#999' : '#666')};
  letter-spacing: -0.2px;
`;

export const ResultValue = styled.div`
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  line-height: 1.4;
  letter-spacing: -0.3px;

  /* Ensure nested content is aligned right */
  & > * {
    display: inline-block;
    text-align: right;
  }
`;
